import { render } from "./PrimaryCareModules.vue?vue&type=template&id=2115df48&lang=pug"
import script from "./PrimaryCareModules.vue?vue&type=script&lang=js"
export * from "./PrimaryCareModules.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__